export default __webpack_public_path__ + "static/media/10.c2721a7a.webp";